
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1xupv_9oywc_145",
  "wizard": "awsui_wizard_1xupv_9oywc_177",
  "refresh": "awsui_refresh_1xupv_9oywc_177",
  "small-container": "awsui_small-container_1xupv_9oywc_184",
  "navigation": "awsui_navigation_1xupv_9oywc_193",
  "number": "awsui_number_1xupv_9oywc_226",
  "circle": "awsui_circle_1xupv_9oywc_242",
  "title": "awsui_title_1xupv_9oywc_253",
  "active": "awsui_active_1xupv_9oywc_284",
  "disabled": "awsui_disabled_1xupv_9oywc_295",
  "enabled": "awsui_enabled_1xupv_9oywc_305",
  "form": "awsui_form_1xupv_9oywc_349",
  "form-header": "awsui_form-header_1xupv_9oywc_354",
  "form-header-content": "awsui_form-header-content_1xupv_9oywc_369",
  "form-component": "awsui_form-component_1xupv_9oywc_373",
  "hidden": "awsui_hidden_1xupv_9oywc_387",
  "collapsed-steps": "awsui_collapsed-steps_1xupv_9oywc_391",
  "collapsed-steps-hidden": "awsui_collapsed-steps-hidden_1xupv_9oywc_396",
  "form-header-component-wrapper": "awsui_form-header-component-wrapper_1xupv_9oywc_400",
  "form-header-component": "awsui_form-header-component_1xupv_9oywc_400",
  "navigation-link": "awsui_navigation-link_1xupv_9oywc_416",
  "navigation-link-item": "awsui_navigation-link-item_1xupv_9oywc_417",
  "navigation-link-label": "awsui_navigation-link-label_1xupv_9oywc_418",
  "navigation-link-active": "awsui_navigation-link-active_1xupv_9oywc_422",
  "navigation-link-disabled": "awsui_navigation-link-disabled_1xupv_9oywc_427",
  "cancel-button": "awsui_cancel-button_1xupv_9oywc_431",
  "previous-button": "awsui_previous-button_1xupv_9oywc_432",
  "primary-button": "awsui_primary-button_1xupv_9oywc_433",
  "skip-to-button": "awsui_skip-to-button_1xupv_9oywc_434",
  "action-buttons": "awsui_action-buttons_1xupv_9oywc_438"
};
  